import React from 'react';
import "./AboutMePage.css";
import Box from "@mui/material/Box";
import AboutMeImage from "../../Images/Hantel.jpeg";
import { contentTexts } from "../ContentText";
import { HorizontalLinePrimary } from "../Components/HorizontalLine/HorizontalLinePrimary";
import {Avatar, Typography, useMediaQuery, useTheme} from "@mui/material";
import TopTitle from "../Components/TopTitle";
import SubTitle from "../Components/SubTitle";

function AboutMePage(props) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <Box
            className="about_me_content"
            ref={props.refs}
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "flex-start",
                justifyContent: "space-between",

            }}
        >
            {!isMobile ? (

            <Box
                className="image_content"
                sx={{
                    flex: 1,
                    maxWidth: { xs: "100%", md: 500 },
                    boxShadow: 2,
                    borderRadius: 2,
                    overflow: "hidden",
                }}
            >
                <img
                    src={AboutMeImage}
                    alt="Christof lifting a dumbbell"
                    style={{ width: "100%", display: "block" }}
                />
            </Box>) : (<></>)}
            <Box
                className="text_content"
                sx={{
                    flex: 1,
                    pl: { xs: 0, md: 4 },
                }}
            >
                {isMobile ? (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,        // adjust space between avatar and text
                        mb: 2,         // margin below this block before the horizontal line
                    }}
                >
                    <Avatar
                        src={AboutMeImage}
                        alt="Christof"
                        sx={{ width: "30vw" , height: "30vw" }}
                    />
                    <Box>
                        <TopTitle>{contentTexts.aboutMeTitle}</TopTitle>
                        <SubTitle>{contentTexts.aboutMeSubtitle}</SubTitle>
                    </Box>
                </Box>)
                    :(<>
                        <TopTitle>{contentTexts.aboutMeTitle}</TopTitle>
                        <SubTitle>{contentTexts.aboutMeSubtitle}</SubTitle>
                        <HorizontalLinePrimary/>
                    </>)}
                <Box sx={{display: "flex", flexDirection: "column", gap: 3, mt: 2}}>
                {contentTexts.aboutMeContent.map((value, index) => (
                        <Typography key={index} className="content_font">
                            {value}
                        </Typography>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default AboutMePage;
